import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Get, Put } from '../../utils/httpProvider';
import { fetchWithAuth } from '../../utils/httpClient';
import { PERSONALTASK_API } from '../../utils/apiUrl.js';

// Constant name for this slice
const SLICE_NAME = 'personalTask';

// Actions
export const getMyAssignmentsAction = createAsyncThunk(
    `${SLICE_NAME}/getMyAssignments`,
    async (filters) => {
        const params = {};
        if (filters?.from) params.from = filters.from;
        if (filters?.to) params.to = filters.to;
        if (filters?.selectedUserId) params.selectedUserId = filters.selectedUserId;
        return Get(PERSONALTASK_API.GET_MY_ASSIGNMENTS, null, Object.keys(params).length ? params : null)
            .then((response) => response)
            .catch((error) => error);
    }
);

export const updateAssignmentStatusAction = createAsyncThunk(
    `${SLICE_NAME}/updateAssignmentStatus`,
    async (model) => {
        const { projectId, data } = model;
        const url = `${PERSONALTASK_API.UPDATE_ASSIGNMENT_STATUS}/${projectId}`;
        const res = await fetchWithAuth(url, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
        });
        if (!res.ok) throw await res.json();
        return res.json().catch(() => ({}));
    }
);

const initialState = {
    myAssignments: [],
    status: 'idle',
    error: null
};

export const personalTaskSlice = createSlice({
    name: SLICE_NAME,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getMyAssignmentsAction.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getMyAssignmentsAction.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const payload = action.payload;
                if (payload) {
                    let rawData = payload.data !== undefined ? payload.data : payload.Data;
                    if (rawData === undefined) rawData = payload;
                    
                    if (rawData && rawData.$values) {
                        state.myAssignments = rawData.$values;
                    } else if (Array.isArray(rawData)) {
                        state.myAssignments = rawData;
                    } else {
                        state.myAssignments = [];
                    }
                } else {
                    state.myAssignments = [];
                }
            })
            .addCase(getMyAssignmentsAction.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            });
    }
});

export default personalTaskSlice.reducer;
